import { render, staticRenderFns } from "./BulkDiscountForm.vue?vue&type=template&id=1b6627c8&scoped=true&"
import script from "./BulkDiscountForm.vue?vue&type=script&lang=js&"
export * from "./BulkDiscountForm.vue?vue&type=script&lang=js&"
import style0 from "./BulkDiscountForm.vue?vue&type=style&index=0&id=1b6627c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6627c8",
  null
  
)

export default component.exports